import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, ErrorCard } from '@wit-support/ui';
import { describePaybackError } from '../errors.js';
function hhmm(ms) {
    const d = new Date(ms);
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
/**
 * Ошибка блока: фраза, «Повторить» и, если на экране остались прошлые
 * данные, — «Показаны данные на ЧЧ:ММ».
 */
export function ErrorBlock({ error, onRetry, retryDisabled = false, shownAt, }) {
    return (_jsx(ErrorCard, { variant: "bordered", role: "alert", children: _jsxs("div", { className: "flex flex-wrap items-center justify-between gap-3", children: [_jsxs("span", { children: [describePaybackError(error), shownAt ? (_jsxs("span", { className: "ml-2 text-[var(--color-text-muted)]", children: ["\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u044B \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 ", hhmm(shownAt)] })) : null] }), onRetry ? (_jsx(Button, { type: "button", size: "sm", variant: "secondary", disabled: retryDisabled, onClick: onRetry, children: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C" })) : null] }) }));
}
//# sourceMappingURL=error-block.js.map